import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Forward = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='m21.764 11.456-7.66-7.257a.75.75 0 0 0-1.266.545V8a.51.51 0 0 1-.504.504C4.38 8.62 1.924 11.566 1.841 19.573c-.002.105.14.142.189.048 1.379-2.69 2.62-4.062 10.304-4.12a.5.5 0 0 1 .504.499v3.256a.75.75 0 0 0 1.266.545l7.66-7.256a.75.75 0 0 0 0-1.09'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M14.62 3.655c-.956-.906-2.532-.228-2.532 1.089v3.014c-3.911.086-6.705.866-8.504 2.812-1.82 1.97-2.452 4.958-2.493 8.995-.01.85 1.176 1.238 1.606.398.668-1.302 1.228-2.134 2.443-2.712 1.255-.597 3.279-.955 6.948-.997v3.002c0 1.317 1.576 1.995 2.532 1.09l7.66-7.257a1.5 1.5 0 0 0 0-2.178z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
